import { SessionControllerApi } from "src/api/api";

export interface IWorkoutApiClients {
    workout: SessionControllerApi;
}

export class WorkoutApiClients {
    private static instance: IWorkoutApiClients;

    private constructor() { }

    static getInstance(basePath: string): IWorkoutApiClients {
        if (WorkoutApiClients.instance == null) {
            WorkoutApiClients.instance = {
                workout: new SessionControllerApi({
                    basePath: basePath,
                    isJsonMime() {
                        return true;
                    }
                }),
            };
        }
        return WorkoutApiClients.instance;
    }
}

